import { useMutation, useQueryClient } from '@tanstack/react-query';
import { trackLogin } from '@/lib/analytics';
import { login, LoginError } from '../api';
import type { LoginCredentials, LoginResponse } from '../types';

/**
 * Hook for user login
 * On success, invalidates the session query to trigger a refetch
 */
export function useLogin() {
  const queryClient = useQueryClient();

  return useMutation<LoginResponse, LoginError, LoginCredentials>({
    mutationFn: login,
    onSuccess: (_data, variables) => {
      trackLogin(variables.username);
      // Invalidate session query to refetch user data
      queryClient.invalidateQueries({ queryKey: ['session'] });
    },
  });
}
